import { render, staticRenderFns } from "./EventCompanyList.vue?vue&type=template&id=2cd31348"
import script from "./EventCompanyList.vue?vue&type=script&lang=js"
export * from "./EventCompanyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports